export default __webpack_public_path__ + "static/media/right_header.d35168ba.svg";